import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import type { DeviceEntry } from "../../types/analytics";
import styles from "./DeviceChart.module.css";

interface DeviceChartProps {
  data: DeviceEntry[];
}

const COLORS = ["#6366f1", "#06b6d4", "#f59e0b", "#10b981", "#ef4444", "#8b5cf6", "#ec4899"];

export function DeviceChart({ data }: DeviceChartProps) {
  if (data.length === 0) {
    return <div className={styles.empty}>No device data</div>;
  }

  // Aggregate by deviceType for pie chart
  const byType = new Map<string, number>();
  for (const entry of data) {
    const key = entry.deviceType || "unknown";
    byType.set(key, (byType.get(key) ?? 0) + entry.count);
  }

  const pieData = Array.from(byType.entries())
    .map(([name, value]) => ({ name, value }))
    .sort((a, b) => b.value - a.value);

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Devices</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={pieData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
            label={({ name, percent }) => `${name} ${((percent ?? 0) * 100).toFixed(0)}%`}
          >
            {pieData.map((_entry, index) => (
              <Cell key={index} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
